import { h } from "preact";
import { Modal, Input, Button, Alert, Typography, Checkbox } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { nanoid } from 'nanoid';

const { Text } = Typography;

const ResetPasswordModal = ({
                                open,
                                onCancel,
                                onOk,
                                loading,
                                consumerUsername,
                                newPassword,
                                setNewPassword,
                                confirmPassword,
                                setConfirmPassword,
                                isTemporary,
                                setIsTemporary
                            }) => {
    const generateRandomPassword = () => {
        const password = nanoid(12);
        setNewPassword(password);
        setConfirmPassword(password);
    };

    return (
        <Modal
            title={`Reset password for ${consumerUsername || 'Consumer'}`}
            open={open}
            onOk={onOk}
            onCancel={onCancel}
            confirmLoading={loading}
            okText="Reset Password"
            cancelText="Cancel"
            width={500}
        >
            <div style={{marginBottom: '16px'}}>
                <Text strong style={{display: 'block', marginBottom: '8px'}}>
                    New Password
                </Text>
                <div style={{display: 'flex', gap: '8px'}}>
                    <Input.Password
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        placeholder="Enter new password"
                        style={{flex: 1}}
                    />
                    <Button
                        icon={<ReloadOutlined/>}
                        onClick={generateRandomPassword}
                        title="Generate random password"
                        type="default"
                    >
                        Generate
                    </Button>
                </div>
            </div>

            <div style={{ marginBottom: '16px' }}>
                <Text strong style={{ display: 'block', marginBottom: '8px' }}>
                    Confirm Password
                </Text>
                <Input.Password
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirm new password"
                />
            </div>

            <div style={{marginBottom: '16px'}} className="password-reset-checkbox">
                <Checkbox
                    checked={isTemporary}
                    onChange={(e) => setIsTemporary(e.target.checked)}
                >
                    Temporary (user must change on next login)
                </Checkbox>
            </div>

            {newPassword && confirmPassword && newPassword !== confirmPassword && (
                <Alert
                    message="Passwords do not match"
                    type="error"
                    showIcon
                    style={{ marginTop: '8px' }}
                />
            )}
        </Modal>
    );
};

export default ResetPasswordModal;